import { DOCUMENT, Location } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Restaurant } from 'src/app/models';
import { DataClientService } from 'src/app/services/data-client.service';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TermsAndConditionsComponent implements OnInit, OnDestroy {
  // Rest info should be added to db: restId-private -> cryp as:
  // "info": {
  //   "nip": "6546168141384138",
  //   "phone": "684684",
  //   "address": "slefjeslifjsleifjsleij",
  //   "regon": "648684136841648",
  //   "krs": "56468464" or false
  // }
  // after that, menu (any) should be published (to copy proper data to restId-public -> cryp)
  public merchantTermsAndConditions: boolean = false;
  public rest: Restaurant = new Restaurant();
  constructor(
    @Inject(DOCUMENT) private _document: Document,
    private _location: Location,
    private db: DataClientService
  ) { }

  async ngOnInit(): Promise<void> {
    this._document.body.classList.add('bodybg-color');    
    if (this.db.currentRestaurant.info !== null) {
      this.updateTermsAndConditions();  
    }
  }

  prevPage() {
    this._location.back();
  }

  updateTermsAndConditions(){
    this.rest = this.db.currentRestaurant;
    this.merchantTermsAndConditions = true;
  }

  ngOnDestroy() {
    this._document.body.classList.remove('bodybg-color');
  }


}
